import React from 'react'
import { MdDragIndicator } from "react-icons/md";
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

const SongsOrder = ({data}) => {
    const {concert, setConcert} = data
    const concertSongs = !Array.isArray(concert?.songs) ? [] : concert?.songs

    // Sort songs by order if it exists, otherwise use array index
    const sortedSongs = [...concertSongs].sort((a, b) => {
        if (a.order !== undefined && b.order !== undefined) {
            return a.order - b.order;
        }
        return 0; // Keep original order if no order property
    });

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        
        const items = Array.from(sortedSongs);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        
        // Update order property for all items
        const updatedItems = items?.map((item, index) => ({
            ...item,
            order: index
        }));
        
        setConcert({
            ...concert,
            songs: updatedItems
        });
    }

    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="songs">
                {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                        {sortedSongs?.filter((x)=>x?.status !== "archived")?.map((song, index) => (
                            <Draggable key={song.id || index} draggableId={song.id || `song-${index}`} index={index}>
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        style={{ margin: "10px", ...provided.draggableProps.style }}
                                    >
                                        <div style={{
                                            fontWeight: "bold",
                                            border: "1px solid #c0bfbf",
                                            borderRadius: "10px",
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            padding: "10px"
                                        }}>
                                            <div 
                                                {...provided.dragHandleProps}
                                                style={{marginRight: "10px"}}
                                            >
                                                <MdDragIndicator size={25} />
                                            </div>
                                            {song?.title}
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    )
}

export default SongsOrder
